import useUTM from 'src/hooks/useUTM';
const UTMManager = () => {
  useUTM();
  return null;
};
export default UTMManager;